import i8n from "@/i18n";
import { Plan } from "leatherman-js/models";
import store from "@/store";

const apiEventMessageMap = {
  "service:change-term": {
    translation: "plan-change-term",
    status: ["pending", "success"],
  },
  "service:set-nickname": {
    translation: "plan-change-name",
    status: ["pending", "success"],
  },
  "cloud-account:enable-cdn": {
    translation: "site-enable-cdn",
    status: ["failure", "pending", "success"],
  },
  "cloud-account:disable-cdn": {
    translation: "site-disable-cdn",
    status: ["failure", "pending", "success"],
  },
};

function dispatchApiEventToast(data) {
  let event = apiEventMessageMap[data.action];
  if (event?.status?.includes(data.status)) {
    const plan = store.getters["plans/get"](data.resource_id);
    store.dispatch("toasts/addToast", {
      variant: "info",
      message: i8n.t(`toasts.${event.translation}-${data.status}-message`, {
        name: plan?.nickname,
      }),
    });
  }
}

const handler = (event, data) => {
  switch (event) {
    case "api-task:add":
      break;
    case "api-task:update":
      dispatchApiEventToast(data);
      break;
    case "service:add":
      let addedPlan = Plan.formatLegacy(data);
      if (addedPlan.environmentType !== "production") {
        return;
      }
      store.dispatch("plans/refreshList");
      store.dispatch("toasts/addToast", {
        variant: "info",
        message:
          data.environment_type === "staging"
            ? i8n.t("toasts.staging-environment-adding-message")
            : i8n.t("toasts.plan-adding-message", { name: addedPlan.nickname }),
      });
      break;
    case "service:delete":
      let deletedPlan = Plan.formatLegacy(data);
      store.dispatch("safeHarbor/refreshStagingEnvironments", data.id);
      store.dispatch("safeHarbor/refreshSiteStagingEnvironmentsByServiceId", data.id);
      if (deletedPlan.environmentType !== "production") {
        return;
      }
      store.dispatch("toasts/addToast", {
        variant: "info",
        message:
          data.environment_type === "staging"
            ? i8n.t("toasts.staging-environment-removing-message")
            : i8n.t("toasts.plan-removed-message", { name: deletedPlan.nickname }),
      });
      store.dispatch("plans/refreshListByPlanId", data.id);
      break;
    case "service:update":
      let updatedPlan = Plan.formatLegacy(data);
      if (data.environment_type === "staging") {
        store.dispatch("safeHarbor/refreshStagingEnvironments", data.id);
        store.dispatch("safeHarbor/refreshSiteStagingEnvironments", data.id);
        store.dispatch("safeHarbor/refreshSiteStagingEnvironmentsByServiceId", data.id);
        if (data.parent_id) {
          store.dispatch("safeHarbor/refreshStagingEnvironments", data.parent_id);
          store.dispatch("safeHarbor/removeStagingEnvironmentUpdate", data.parent_id);
        }
        if (data?.cloud_account?.reference_account_id) {
          store.dispatch(
            "safeHarbor/refreshSiteStagingEnvironments",
            data?.cloud_account?.reference_account_id
          );
        }
      }
      if (updatedPlan.environmentType !== "production") {
        return;
      }
      store.dispatch("plans/refreshItem", data.id);
      store.dispatch("plans/refreshListByPlanId", data.id);
      store.dispatch("auth/clientInfo");
      break;
  }
};

export default handler;
